import { useState } from "react";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { useDispatch } from "react-redux";
import { ventasOpenModalFormatos } from "../../../../actions/libros/libros-ventas.actions";
import './styles/ModalFormatosVentas.css';

const RESOURCES_FOLDER = process.env.REACT_APP_RESOURCES_FOLDER;
const UTILITIES = process.env.REACT_APP_UTILITIES;

interface btnPlantilla {
  label: string,
  files: Array<string>
}

interface buttonsPlantilla {
  buttons: Array<btnPlantilla>
}

export const ModalDescargarPlantillas: React.FC<buttonsPlantilla> = ({ buttons }) => {
  const dispatch = useDispatch();
  const [errorDescarga, setErrorDescarga] = useState('');

  const downloadFiles = (fileNames: string[]) => {
    setErrorDescarga('');
    fileNames.forEach(fileName => {
      const urlPlantilla = `${UTILITIES}/${RESOURCES_FOLDER}/${fileName}` + '?timestamp=' + new Date().getTime();
  
      fetch(urlPlantilla)
        .then(response => {
          if (!response.ok) throw new Error(`${response.status}`);
          return response.blob();
        })
        .then(blob => {
          const urlDescarga = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = urlDescarga;
          link.download = `${fileName}`; // Usa el nombre del archivo actual para la descarga
          
          document.body.appendChild(link);
          link.click();
          
          document.body.removeChild(link);
          window.URL.revokeObjectURL(urlDescarga);
        })
        .catch(error => {
          console.error('Error al descargar el archivo:', error);
          setErrorDescarga(
            `No se pudo descargar «${fileName}». Vuelva a intentarlo; si el problema sigue, avise a soporte.`
          );
        });
    });
  }

  return (
    <ModalBase>
      <div className="dte-send-email-container">
        <div>
          <h3 className="card-title">Descargar plantillas (JSON y EXCEL)</h3>
        </div>
        <div className="separador"/>
        <h1 className="m" style={{ fontWeight: '400', margin: '0', lineHeight: 'normal'}}>Descarga aquí las plantillas disponibles para realizar cargas al sistema. Al seleccionar una plantilla, los archivos se descargarán de forma secuencial.</h1>
        <div className="formatos__container">
         {
          buttons.map((button:any, index) => (
            <button
              key={index}
              className="formatos__button button w-inline-block"
              onClick={() => downloadFiles(button.files)}
            >
              {button.label}
            </button>
          ))
          }
        </div>
        {errorDescarga && (
          <h1 className="m" style={{ fontWeight: '400', margin: '12px 0 0', lineHeight: 'normal', color: '#c0392b' }}>
            {errorDescarga}
          </h1>
        )}
        <div className="dte-send-email-footer">
          <button className="button transparent w-inline-block" onClick={() => dispatch(ventasOpenModalFormatos(false))}>
            Cerrar
          </button>
        </div>
      </div>
    </ModalBase>
  )
}